import { render, staticRenderFns } from "./ResultTab.vue?vue&type=template&id=7851cdfd&scoped=true&"
import script from "./ResultTab.vue?vue&type=script&lang=js&"
export * from "./ResultTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7851cdfd",
  null
  
)

export default component.exports